var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.078 4.34c-3.35-.415-6.578-2.926-7.926-4.094a1.003 1.003 0 00-1.317 0C7.487 1.42 4.264 3.926.909 4.34A1.025 1.025 0 000 5.401C.415 15.59 7.115 20.06 9.026 21.121a.998.998 0 00.982 0c1.89-1.062 8.585-5.532 9.025-15.72a1.025 1.025 0 00-.955-1.062zM9.493 15.928a5.31 5.31 0 110-10.619 5.31 5.31 0 010 10.619z",
    fill: "url(#prefix__paint0_linear_1_10966)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.567 10.244a1.534 1.534 0 100-3.067 1.534 1.534 0 000 3.067zm1.417 1.306H8.165a1.21 1.21 0 00-1.162 1.253v.361a.366.366 0 00.355.383h4.455a.366.366 0 00.35-.383v-.36a1.21 1.21 0 00-1.179-1.259v.005z",
    fill: "url(#prefix__paint1_linear_1_10966)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_1_10966",
    x1: 9.517,
    y1: 0,
    x2: 9.517,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8684B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161551",
    stopOpacity: 0.94
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_1_10966",
    x1: 9.583,
    y1: 7.176,
    x2: 9.583,
    y2: 13.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8684B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161551",
    stopOpacity: 0.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetails);
export default __webpack_public_path__ + "static/media/account-details.81eac6ec.svg";
export { ForwardRef as ReactComponent };